import React from 'react';
import Header from '../index/components/Header/Header';
import ViewAllCards from './components/ViewAllCards/ViewAllCards';
import NavigationMobileMenu from '@/shared/components/NavigationMobileMenu/NavigationMobileMenu';
import FlotingCart from '../index/components/Header/floatingcart';

const ViewAll: React.FC = () => {
  return (
    <div className="view-all-page">
      <Header />
      <ViewAllCards />
      <FlotingCart />
      <NavigationMobileMenu />
    </div>
  );
};

export default ViewAll;
